import { render, staticRenderFns } from "./ClientsKpiCard.vue?vue&type=template&id=669cf76e&scoped=true"
import script from "./ClientsKpiCard.vue?vue&type=script&lang=js"
export * from "./ClientsKpiCard.vue?vue&type=script&lang=js"
import style0 from "./ClientsKpiCard.vue?vue&type=style&index=0&id=669cf76e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669cf76e",
  null
  
)

export default component.exports